export default __webpack_public_path__ + "5669bd3233be88f7c041b651e1f34d50.png";